import BuildingModel from "../../models/BuildingModel";
import FloorModel from "../../models/FloorModel";
import DeviceModel from "../../models/DeviceModel";
import { createSlice } from "@reduxjs/toolkit";
import { requestAllDevicesByLocationId } from "./mapDeviceRequest";

type FullFloorModel = {
  deviceList: DeviceModel[],
} & FloorModel;

export type FullBuildingModel = {
  floorList: FullFloorModel[],
} & BuildingModel;

type MapDeviceSlice = {
  deviceStructure: FullBuildingModel[],
}

const initialState: MapDeviceSlice = {
  deviceStructure: [],
}

export const mapDeviceSlice = createSlice({
  name: 'mapDeviceList',
  initialState,
  reducers: {
    clearMapDeviceState: (state) => {
      state.deviceStructure = [];
    }
  },
  extraReducers: builder =>
    builder.addCase(requestAllDevicesByLocationId.fulfilled, (state, action) => {
      state.deviceStructure = action.payload;
    })
});

export const { clearMapDeviceState } = mapDeviceSlice.actions;